import { Box } from 'app/components/design-system-components'
import { CheckboxesList } from 'app/components/design-system-components/list-filters/CheckboxesList'
import { DropdownBodySectionHeader } from 'app/components/design-system-components/list-filters/DropdownBodySectionHeader'
import { theme } from 'app/match/applicationReportPDF/assets/theme'

export const sortFiltersFields = {
  sort: 'sort',
}

export const isSortFilterApplied = (sortFilterValues: any) =>
  sortFilterValues &&
  sortFilterValues[sortFiltersFields.sort] &&
  Object.values(sortFilterValues[sortFiltersFields.sort]).length

export const sortDataExtractor = (filterValues: any) => {
  const { [sortFiltersFields.sort]: sortesObj } = filterValues
  return {
    sort: Object.values(sortesObj || {}).map(
      ({ optionMeta }: any) => optionMeta.id,
    ),
  }
}

export const getSortFilterState = (sort: any) =>
  Object.values(sort?.sort || {}).map(({ optionMeta }: any) => optionMeta?.id)

export const SortAppliedFilterRenderer = ({ filterValues }: any) => {
  const { [sortFiltersFields.sort]: sort } = filterValues
  return Object.values(sort)
    .map((sortObj: any) => sortObj.optionMeta.displayText)
    .join(', ')
}

export const SortFilterBody = ({
  formBag: { values, setFieldValue },
  sortOptions,
}: any) => {
  const onCheckBoxClicked = (checked: boolean, option: any) => {
    const sortValues = values[sortFiltersFields.sort]

    if (checked) {
      setFieldValue(sortFiltersFields.sort, {
        [option.optionMeta.id]: option,
      })
    } else {
      const { [option.optionMeta.id]: uncheckedOption, ...otherOptions } =
        sortValues
      setFieldValue(sortFiltersFields.sort, {
        ...otherOptions,
      })
    }
  }

  const sortValues = values[sortFiltersFields.sort] || {}

  let sortFilterOptions = Object.values(sortOptions).map((sort: any, idx) => ({
    option: sort,
    optionMeta: {
      id: sort.value,
      displayText: sortOptions[idx]?.name,
      noSeparator: true,
    },
  }))

  sortFilterOptions = sortFilterOptions.slice(1)

  return (
    <>
      <Box style={{ maxHeight: '300px', overflowY: 'auto' }}>
        <DropdownBodySectionHeader
          header="SORT"
          containerProps={{ mb: theme.space[4] + 'px' }}
        />
        <CheckboxesList
          options={sortFilterOptions}
          checkedOptions={sortValues}
          onCheckBoxClicked={onCheckBoxClicked}
        />
      </Box>
    </>
  )
}
